import React, { FC } from "react";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import columns from "../../models/ColumnDefinitions/UserLoginColumns";
import { removeColumns } from "../../models/utilities/columnHelper";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import searchColumns from "../../models/search/UserLoginSearch";
import TableTab from "../tabs/table-tab";

interface Props {
    itemId: string;
    user: any;
    translate: any;
    lookup: Lookup[];
    dataMethod: (query?: ListQuery) => Promise<ListData>;
    setShowManagedModal: (boolean: boolean) => void;
    setDataRefresh: (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => void;
}

const AssignedUserLogins: FC<Props> = ({ itemId, user, translate, lookup, dataMethod, setShowManagedModal, setDataRefresh }) => {
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => { setDataRefresh(() => refreshData); };
    
    return (
        <div className="h-full">
            <TableContextProvider
                manualDataRefresh={manualDataRefresh}
                dataMethod={dataMethod}
                tableDescriptor={removeColumns(columns, ["securityPolicy"])}
                searchDescriptor={searchColumns}
                useTable
                usePagination
                useSearch
                useSort
                useFilter
                lookup={lookup}>
                <TableTab
                    title={translate.byKey(TranslationKeys.logins)}
                    selectRows={false}
                    cyName='assignedUserLogins'>
                    <button
                        type="button"
                        className="flex ml-8 px-4 bg-lime rounded-lg shadow text-white text-sm items-center"
                        id="manageBtn"
                        onClick={() => { setShowManagedModal(true); }}>
                        {translate.byKey(TranslationKeys.manage)}
                    </button>
                </TableTab>
            </TableContextProvider>
        </div>
    );
};

export default AssignedUserLogins;
